import {
  Facebook,
  Instagram,
  Twitter,
  LinkedIn,
  YouTube,
} from "@mui/icons-material";
import {
  Box,
  Container,
  Unstable_Grid2,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { Link } from "gatsby";
import React from "react";

export const Footer = () => (
  <Box sx={{ background: "white", pt: 3, pb: 1, mt: 3 }}>
    <Container maxWidth="lg">
      <Unstable_Grid2 container spacing={3}>
        <Unstable_Grid2 xl={4}>
          <Typography
            variant="h5"
            noWrap
            sx={{
              // lineHeight: 1,
              mb: 2,
            }}
          >
            <Box
              component="span"
              sx={{
                backgroundImage:
                  "linear-gradient(0deg, rgb(64, 9, 3), rgb(150, 23, 7))",
                backgroundSize: "100%",
                backgroundRepeat: "repeat",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: 900,
              }}
            >
              {"ВЕСТИ".toUpperCase()}
            </Box>
            <span
              style={{
                fontWeight: 900,
                textDecoration: "none",
                color: "black",
              }}
            >
              МАК.MK
            </span>
          </Typography>
          <Typography
          // mb={3}
          >
            Независен медиум кој објавува проверени и навремени вести од Северна
            Македонија и светот, со фокус на објективно информирање.
          </Typography>

          {/* <Typography>
            <Link to="/privacy-policy">Политика за поверителност</Link>
          </Typography>
          <Typography>
            <Link to="/programen-tekst">Програмен текст</Link>
          </Typography> */}
        </Unstable_Grid2>
        <Unstable_Grid2 xl={4}>
          {/* <Typography variant="h5" fontWeight={"bold"} mb={3} color="primary">
            БИЛЕТИН
          </Typography>
          <Typography mb={3}>
            Добијте ги најважните Вестимак вести секоја утро во вашата е-пошта.
          </Typography>
          <TextField size="small" sx={{ mr: 2 }} />
          <Button variant="contained">ЗАПИШИ СЕ</Button> */}
        </Unstable_Grid2>
        <Unstable_Grid2 xl={4}>
          <Typography
            variant="h5"
            fontWeight={"bold"}
            mb={2}
            color="primary.dark"
          >
            Следи нè!
          </Typography>
          <Typography mb={3}>
            Следете нè на социјалните мрежи и помогнете во поддршката на
            независното новинарство. Вашата поддршка значи многу!
          </Typography>
          <Link to="https://www.facebook.com/vestimak.mk" target={"_blank"}>
            <Facebook fontSize="large" sx={{ mr: 3, color: "primary.dark" }} />
          </Link>
          <Link to="https://www.instagram.com/vestimakmk" target={"_blank"}>
            <Instagram fontSize="large" sx={{ mr: 3, color: "primary.dark" }} />
          </Link>
          <Link to="https://x.com/vestimakmk" target={"_blank"}>
            <Twitter fontSize="large" sx={{ mr: 3, color: "primary.dark" }} />
          </Link>
          {/* <Link
            to="https://www.gofundme.com/f/mevv7-donirajte-za-nasiot-medium-da-ostane-nezavisen"
            target={"_blank"}
          >
            <Box
              component={"svg"}
              xmlns="http://www.w3.org/2000/svg"
              width={35}
              height={35}
              viewBox="0 0 24 24"
              sx={{ color: "primary.dark" }}  
            >
              <title>{"GoFundMe icon"}</title>
              <path
                fill="currentColor"
                d="M21.624 4.08 17.4 7.15a1.502 1.502 0 0 0-.33 2.092c.489.67 1.421.813 2.091.331l4.222-3.07c.67-.49.813-1.423.332-2.093a1.488 1.488 0 0 0-2.092-.33zm-9.649-1.182c-.828 0-1.498.67-1.498 1.497v2.521a1.497 1.497 0 1 0 2.996 0v-2.52c0-.829-.67-1.498-1.498-1.498zM.288 4.41c-.49.67-.339 1.603.33 2.093l4.223 3.07c.67.49 1.603.339 2.092-.331.49-.67.339-1.603-.331-2.092L2.38 4.08a1.5 1.5 0 0 0-2.092.33zm3.695 7.79a11.959 11.959 0 0 1 7.992-3.056c3.07 0 5.87 1.159 7.993 3.055zm14.555 1.633c-1.347 0-2.236.443-2.8.993-.595.587-1.023 1.505-1.023 2.65 0 1.301.564 2.144 1.009 2.588.843.843 1.926 1.038 2.829 1.038 1.482 0 2.28-.458 2.784-.947a3.06 3.06 0 0 0 .828-1.408h-2.34a1.16 1.16 0 0 1-.43.459c-.308.165-.736.181-.797.181-.549 0-.858-.188-1.008-.339-.294-.286-.43-.775-.43-1.144h5.095v-.263c0-.76-.12-1.957-1.083-2.875-.814-.768-1.836-.933-2.634-.933zm.06 1.558c.241 0 .685.045 1.008.368.188.188.339.475.4.738h-2.77c.045-.308.203-.557.369-.738.256-.263.58-.368.993-.368zm-16.85-1.355h2.445v.828c.58-.7 1.377-.949 2.047-.949.49 0 .949.106 1.317.31.505.263.783.639.948.977.28-.489.626-.782.934-.948.49-.278.963-.338 1.423-.338.503 0 1.331.075 1.896.624.61.595.64 1.408.64 1.882v4.455H10.95v-3.38c0-.722-.075-1.21-.353-1.467-.136-.12-.324-.226-.64-.226a.986.986 0 0 0-.722.279c-.414.399-.444.963-.444 1.302v3.507H6.346v-3.38c0-.654-.045-1.18-.324-1.467-.21-.226-.49-.278-.737-.278-.264 0-.474.045-.67.248-.429.414-.429 1.069-.429 1.498v3.379H1.74v-6.856Z"
              />
            </Box>
          </Link> */}
          {/* <LinkedIn color="primary" fontSize="large" sx={{ mr: 3 }} />
          <YouTube color="primary" fontSize="large" sx={{ mr: 3 }} /> */}
        </Unstable_Grid2>
      </Unstable_Grid2>
      <Typography>© 2025. Сите права запазени</Typography>
    </Container>
  </Box>
);
